<template>
  <v-card>
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card-title class="float-left">
      Détails du spot TV : {{ resolveAttrValue(tvSpot, 'title') }}
    </v-card-title>

    <LocalSwitcher
      @updateCurrentLocale="updateCurrentLocale($event)"
    ></LocalSwitcher>

    <div class="clear"></div>

    <v-card-text>
      <v-form
        v-model="valid"
        class="multi-col-validation mt-5"
        @submit.prevent="checkForm"
      >
        <p v-if="errors.length">
          <v-alert
            v-for="(error, index) in errors"
            :key="index"
            text
            dense
            type="error"
          >
            {{ error.title }}
          </v-alert>
        </p>

        <Snackbar
          v-if="successMessage"
          :key="generateUniqueId()"
          :snackbar-state="snackbar"
          :success-message="successMessage"
        ></Snackbar>

        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <h4>Description du spot TV</h4>
                    <br>
                    <v-text-field
                      v-model="title[currentLocale]"
                      label="Titre"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Titre"
                      hide-details
                    >
                      <template v-slot:append>
                        <country-flag
                          class="inner-input-flag"
                          :country="currentLocale === 'en' ? 'gb' : currentLocale"
                          size="normal"
                          shadow
                        />
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="videoId[currentLocale]"
                      label="Video ID"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Video ID"
                      hide-details
                    >
                      <template v-slot:append>
                        <country-flag
                          class="inner-input-flag"
                          :country="currentLocale === 'en' ? 'gb' : currentLocale"
                          size="normal"
                          shadow
                        />
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="videoTitle[currentLocale]"
                      label="Titre de la vidéo"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Titre de la vidéo"
                      hide-details
                    >
                      <template v-slot:append>
                        <country-flag
                          class="inner-input-flag"
                          :country="currentLocale === 'en' ? 'gb' : currentLocale"
                          size="normal"
                          shadow
                        />
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="videoDescription[currentLocale]"
                      label="Description de la vidéo"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Description de la vidéo"
                      hide-details
                    >
                      <template v-slot:append>
                        <country-flag
                          class="inner-input-flag"
                          :country="currentLocale === 'en' ? 'gb' : currentLocale"
                          size="normal"
                          shadow
                        />
                      </template>
                    </v-text-field>

                    <v-divider class="v-divider-entity mt-5 mb-5"></v-divider>

                    <v-text-field
                      v-model="entityData.position"
                      label="Position"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Position"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              class="mt-5 mr-2"
              color="primary"
              :disabled="!valid"
              type="submit"
            >
              Valider
            </v-btn>

            <v-btn
              class="mt-5"
              text
              :to="{ name: 'tvSpotList' }"
            >
              Retour
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import config from '../../../config'
import Snackbar from '@/components/Common/Snackbar'
import Loader from '@/components/Common/Loader'
import LocalSwitcher from '@/components/Common/LocalSwitcher'

export default {
  components: {
    LocalSwitcher,
    Snackbar,
    Loader
  },
  data () {
    return {
      valid: false,
      errors: [],
      snackbar: false,
      successMessage: null,
      loading: false,
      currentLocale: 'fr',
      id: [],
      title: [],
      videoId: [],
      videoTitle: [],
      videoDescription: [],
      tvSpot: null,
      entityData: {
        id: null,
        position: null,
        currentLocale: 'fr',
        defaultLocale: 'fr',
        newTranslations: {}
      }
    }
  },
  created () {
    this.getTvSpot()
  },
  methods: {
    checkForm () {
      this.errors = []

      if (this.valid) {
        this.putTvSpot()
      }
    },
    getTvSpot () {
      const tvSpotId = this.$route.params.tvSpotId

      this.loading = true

      Vue.prototype.$http
        .get(config.apiUrl + '/api/tv-spots/' + tvSpotId, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.tvSpot = response.data
            this.entityData.id = this.tvSpot.id
            this.entityData.position = this.tvSpot.position

            const translations = this.tvSpot.translations

            if (translations) {
              for (const [currentKey] of Object.entries(translations)) {
                let currentTranslation = translations[currentKey]

                this.id[currentKey] = currentTranslation.id
                this.title[currentKey] = currentTranslation.title
                this.videoId[currentKey] = currentTranslation.videoId
                this.videoTitle[currentKey] = currentTranslation.videoTitle
                this.videoDescription[currentKey] = currentTranslation.videoDescription
              }
            }

            this.valid = true
          }

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    putTvSpot () {
      this.loading = true
      this.valid = false
      this.successMessage = null

      this.handleTranslations([
        'id',
        'title',
        'videoId',
        'videoTitle',
        'videoDescription'
      ])

      Vue.prototype.$http
        .put(config.apiUrl + '/api/tv-spots/' + this.entityData.id, this.entityData, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.tvSpot = response.data

            const translations = this.tvSpot.translations

            if (translations) {
              for (const [currentKey] of Object.entries(translations)) {
                let currentTranslation = translations[currentKey]

                this.id[currentKey] = currentTranslation.id
                this.title[currentKey] = currentTranslation.title
                this.videoId[currentKey] = currentTranslation.videoId
                this.videoTitle[currentKey] = currentTranslation.videoTitle
                this.videoDescription[currentKey] = currentTranslation.videoDescription
              }
            }

            this.snackbar = true
            this.successMessage = 'Spot TV mis à jour avec succès.'
            this.valid = true
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          this.successMessage = null

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    handleTranslations (attributes) {
      for (let i = 0; i < attributes.length; i++) {
        const currentAttribute = attributes[i]

        for (const [currentKey, currentValue] of Object.entries(this[currentAttribute])) {
          let translation = {
            locale: currentKey,
            empty: false
          }

          translation[currentAttribute] = currentValue

          const currentObjState = this.entityData.newTranslations[currentKey]

          this.entityData.newTranslations[currentKey] = { ...currentObjState, ...translation }
        }
      }
    },
    updateCurrentLocale (locale) {
      this.currentLocale = locale
      this.successMessage = null
    },
    resolveAttrValue (data, attr) {
      if (!data) {
        return '-'
      }

      const translations = data.translations

      if (translations && translations.fr) {
        return translations.fr[attr]
      }

      if (data[attr]) {
        return data[attr]
      }

      return '-'
    }
  }
}
</script>
